<article class="tile-card-deposit card card-1" matRipple>
    <div class="menuCardContainer">
        <div class="inner-card">
            <div class="cardContainer">
                <div *ngIf="records && records.length > 0">
                    <table style="width: 100%; border-spacing: 0;">
                        <tr>
                            <th>{{deposit.data.object_name}}</th>
                            <th class="th-spacing align-right">SCU</th>
                            <th class="th-spacing align-right">aUEC</th>
                        </tr>
                        <tr *ngFor="let row of records"  [style.color]="getRowColor(row)">
                            <td class="">{{row.data.name}}</td>
                            <td class="td-spacing align-right">{{row.data.pieces}}</td>
                            <td class="td-spacing align-right">{{(row.data.pieces * row.data.price / 1000) | number:'1.0-1'}}k</td>
                        </tr>

                        <tr [style.color]="'#00c853'">
                            <td class="bottom-row"></td>
                            <td class="td-spacing align-right bottom-row">{{sum(records, 'pieces')| number:'1.0-1'}}</td>
                            <td class="td-spacing align-right bottom-row">{{sumProfit(records) / 1000 | number:'1.0-1'}}k</td>
                        </tr>
                        <tr>
                            <td colspan="6" class="align-left bottom-row"><pre [innerHTML]="deposit.data.deposit_comment"></pre></td>
                        </tr>
                        <tr>
                            <td class="bottom-row" colspan="2">Scout: <span class="player-name">{{deposit.data.miner_name}}</span></td>
                            <td class="bottom-row" colspan="1">Miner: <span class="player-name">{{deposit.data.scout_name}}</span></td>
                        </tr>
                        <tr *ngIf="deposit.data.coordinate_location">
                            <td class="bottom-row" colspan="6">{{deposit.data.coordinate_location}}, {{deposit.data.coordinate_x}},
                                {{deposit.data.coordinate_y}},{{deposit.data.coordinate_d}}°</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</article>
